module.exports = __webpack_public_path__ + "img/icon-left-arrow.43204ca4.svg";